import ninegrid from "../index.js";
import { ngEditableEx } from "./_ngCell.js";

class ngInputColor extends ngEditableEx
{
	#target;
	
	constructor() {
		super();
		this.applyBaseStyle();
	}
	
	connectedCallback() {
		
		this.shadowRoot.innerHTML = `
			<input type="color" required />
			<button tabindex="-1"></button>
		`;
		
		super.connectedCallback();
		
		this.#target	= this.shadowRoot.querySelector("input");
		
		$("button", this.shadowRoot).on("click", e => { $("input", this.shadowRoot).trigger("click") });
		
		$(this.cell).on("keydown", e => {
			switch (e.target.tagName) {
			case "TH": case "TD":
				if (["Enter"].includes(e.code)) {
					$(this.#target).trigger("click");
				}
				break;
			}
		});
	
		this.#target.addEventListener("keydown", e => {
			if (["Enter"].includes(e.code)) {
				$(this.#target).trigger("click");
			}
			else if (["Escape"].includes(e.code)) {
				this.owner.cell.currentCell = this.cell;
			}
			else if (["Tab","PageUp","PageDown","ArrowUp","ArrowDown","ArrowLeft","ArrowRight"].includes(e.code)) {
				this.owner.cell.currentCell = this.cell;
				this.owner.cell.moveCell(e);
			}
		});
	};

	dataRefresh = (v) => {

		if (this.#isValidColor(this.value)) {
			this.#target.value = ninegrid.nvl(this.value, "#ffffff");
			ninegrid.j.querySelectorAll(this).removeClass("invalid");
		}
		else {
			this.#target.value = "#ffffff";
			ninegrid.j.querySelectorAll(this).addClass("invalid");
		}
		
		this.#target.setAttribute("title", this.value);

		if (!v) this.reset();
	};
	
	#isValidColor = (v) => {

		if (ninegrid.isNull(v)) return true;
		
		if (typeof v !== "string" || v.length != 7 || !v.startsWith("#")) return false;
		
		var r	= parseInt(v.substr(1,2), 16);
		var g	= parseInt(v.substr(3,2), 16);
		var b	= parseInt(v.substr(5,2), 16);

		if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) return false;
		
		return true;
	}
}

if (!customElements.get('ng-input-color')) {
	customElements.define("ng-input-color", ngInputColor);
}
